
import { Settings as SettingsIcon } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const SettingsHeader = () => {
  const { t } = useLanguage();

  return (
    <div className="text-center mb-8">
      <img 
        src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=300&fit=crop" 
        alt="Settings configuration" 
        className="w-full h-64 object-cover rounded-lg mb-6"
      />
      <h1 className="text-4xl font-bold text-ice-white mb-2 flex items-center justify-center gap-3">
        <SettingsIcon className="w-10 h-10 text-pink-500" />
        {t('settings')}
      </h1>
      <p className="text-xl text-gray-300">{t('settings_subtitle')}</p>
    </div>
  );
};

export default SettingsHeader;
